<template>
  <div class="OSDI">
    <div class="OSDICon">
      <!-- <div class="title" style="font-family: YMC;">{{ $t('langcfg.txtOSDIIndex') }}</div> -->
      <div class="title">
        <!-- 带商标OSDI 样式拼接 -->
        <div style="margin-right: 30px">
          <span style="position: relative; left: 10px">{{ $t("langcfg.txtOSDIHeader") }}</span>
          <span class="firstCopyRight">©</span>
          <span class="CopyRightbro">(OSDI</span>
          <span style="left: -20px" class="firstCopyRight">©</span>
          <span class="CopyRightson">)</span
          ><span style="left: -26px" class="firstCopyRight">2</span>
        </div>
      </div>
      <div class="loopData">
        <span class="tip">{{ $t(`langcfg.${data0.tip}`) }}</span>
        <h4 class="smtitle">{{ $t(`langcfg.${data0.title}`) }}</h4>
        <el-radio-group v-model="radiovalue0" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in datazh_CN.item"
            :label="item.score"
            :key="item.score"
            v-show="country === 'zh_CN'"
            border
            >{{ $t(`langcfg.${item.text}`) }}</el-radio
          >
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data0.item"
            :label="item.score"
            :key="`${item.score}1`"
            v-show="country !== 'zh_CN'"
            border
            >{{ $t(`langcfg.${item.text}`) }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="loopData">
        <h4 class="smtitle">{{ $t(`langcfg.${data1.title}`) }}</h4>
        <el-radio-group v-model="radiovalue1" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in datazh_CN.item"
            :label="item.score"
            :key="item.score"
            v-show="country === 'zh_CN'"
            border
            >{{ $t(`langcfg.${item.text}`) }}</el-radio
          >
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data0.item"
            :label="item.score"
            :key="`${item.score}2`"
            v-show="country !== 'zh_CN'"
            border
            >{{ $t(`langcfg.${item.text}`) }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="loopData">
        <h4 class="smtitle">{{ $t(`langcfg.${data2.title}`) }}</h4>
        <el-radio-group v-model="radiovalue2" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in datazh_CN.item"
            :label="item.score"
            :key="item.score"
            v-show="country === 'zh_CN'"
            border
            >{{ $t(`langcfg.${item.text}`) }}</el-radio
          >
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data0.item"
            :label="item.score"
            :key="`${item.score}3`"
            v-show="country !== 'zh_CN'"
            border
            >{{ $t(`langcfg.${item.text}`) }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="loopData">
        <h4 class="smtitle">{{ $t(`langcfg.${data3.title}`) }}</h4>
        <el-radio-group v-model="radiovalue3" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in datazh_CN.item"
            :label="item.score"
            :key="item.score"
            v-show="country === 'zh_CN'"
            border
            >{{ $t(`langcfg.${item.text}`) }}</el-radio
          >
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data0.item"
            :label="item.score"
            :key="`${item.score}4`"
            v-show="country !== 'zh_CN'"
            border
            >{{ $t(`langcfg.${item.text}`) }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="loopData">
        <h4 class="smtitle">{{ $t(`langcfg.${data4.title}`) }}</h4>
        <el-radio-group v-model="radiovalue4" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in datazh_CN.item"
            :label="item.score"
            :key="`${item.score}5`"
            v-show="country === 'zh_CN'"
            border
            >{{ $t(`langcfg.${item.text}`) }}</el-radio
          >
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data0.item"
            :label="item.score"
            :key="`${item.score}6`"
            v-show="country !== 'zh_CN'"
            border
            >{{ $t(`langcfg.${item.text}`) }}</el-radio
          >
        </el-radio-group>
      </div>
      <!-- -- -->
      <div class="loopData">
        <span class="tip">{{ $t(`langcfg.${data5.tip}`) }}</span>
        <h4 class="smtitle">{{ $t(`langcfg.${data5.title}`) }}</h4>
        <el-radio-group v-model="radiovalue5" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data5.item"
            :label="item.score"
            :key="item.score"
            border
            >{{ $t(`langcfg.${item.text}`) }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="loopData">
        <h4 class="smtitle">{{ $t(`langcfg.${data6.title}`) }}</h4>
        <el-radio-group v-model="radiovalue6" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data5.item"
            :label="item.score"
            :key="item.score"
            border
            >{{ $t(`langcfg.${item.text}`) }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="loopData">
        <h4 class="smtitle">{{ $t(`langcfg.${data7.title}`) }}</h4>
        <el-radio-group v-model="radiovalue7" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data5.item"
            :label="item.score"
            :key="item.score"
            border
            >{{ $t(`langcfg.${item.text}`) }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="loopData">
        <h4 class="smtitle">{{ $t(`langcfg.${data8.title}`) }}</h4>
        <el-radio-group v-model="radiovalue8" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data5.item"
            :label="item.score"
            :key="item.score"
            border
            >{{ $t(`langcfg.${item.text}`) }}</el-radio
          >
        </el-radio-group>
      </div>
      <!-- -- -->
      <div class="loopData">
        <span class="tip">{{ $t(`langcfg.${data9.tip}`) }}</span>
        <h4 class="smtitle">{{ $t(`langcfg.${data9.title}`) }}</h4>
        <el-radio-group v-model="radiovalue9" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data9.item"
            :label="item.score"
            :key="item.score"
            border
            >{{ $t(`langcfg.${item.text}`) }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="loopData">
        <h4 class="smtitle">{{ $t(`langcfg.${data10.title}`) }}</h4>
        <el-radio-group v-model="radiovalue10" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data9.item"
            :label="item.score"
            :key="item.score"
            border
            >{{ $t(`langcfg.${item.text}`) }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="loopData">
        <h4 class="smtitle">{{ $t(`langcfg.${data11.title}`) }}</h4>
        <el-radio-group v-model="radiovalue11" size="medium">
          <el-radio
            @change="radioClick"
            v-for="(item, index) in data9.item"
            :label="item.score"
            :key="item.score"
            border
            >{{ $t(`langcfg.${item.text}`) }}</el-radio
          >
        </el-radio-group>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OSID",
  data() {
    return {
      country: "",
      radiovalue0: "",
      radiovalue1: "",
      radiovalue2: "",
      radiovalue3: "",
      radiovalue4: "",
      // ---
      radiovalue5: "",
      radiovalue6: "",
      radiovalue7: "",
      radiovalue8: "",
      radiovalue9: "",
      // ---
      radiovalue10: "",
      radiovalue11: "",
      data0: {
        tip: "txtOSDIHeadlineOne",
        title: "txtOSDIQuestionOne",
        item: [
          { text: "txtOSDIQuestionOne_itemOne", score: "4" },
          { text: "txtOSDIQuestionOne_itemTwo", score: "3" },
          { text: "txtOSDIQuestionOne_itemThree", score: "2" },
          { text: "txtOSDIQuestionOne_itemFour", score: "1" },
          { text: "txtOSDIQuestionOne_itemFive", score: "0" }
        ]
      },
      datazh_CN: {
        tip: "txtOSDIHeadlineOne",
        title: "txtOSDIQuestionOne",
        item: [
          { text: "txtOSDIQuestionOne_itemOne", score: "4" },
          { text: "txtOSDIQuestionOne_itemTwo", score: "3" },
          { text: "txtOSDIQuestionOne_itemThree", score: "2" },
          { text: "txtOSDIQuestionOne_itemFour", score: "1" },
          { text: "txtOSDIQuestionOne_itemFive", score: "0" }
        ]
      },
      data1: { title: "txtOSDIQuestionTwo", item: [] },
      data2: { title: "txtOSDIQuestionThree", item: [] },
      data3: { title: "txtOSDIQuestionFour", item: [] },
      data4: { title: "txtOSDIQuestionFive", item: [] },
      //
      data5: {
        tip: "txtOSDIHeadlineTwo",
        title: "txtOSDIQuestionSix",
        item: [
          { text: "txtOSDIQuestionOne_itemOneOther", score: "4" },
          { text: "txtOSDIQuestionOne_itemTwo", score: "3" },
          { text: "txtOSDIQuestionOne_itemThree", score: "2" },
          { text: "txtOSDIQuestionOne_itemFourAnother", score: "1" },
          { text: "txtOSDIQuestionOne_itemOneOther_never", score: "0" },
          { text: "txtOSDIQuestionOne_itemSixOther", score: "-1" }
        ]
      },
      data6: { title: "txtOSDIQuestionSeven", item: [] },
      data7: { title: "txtOSDIQuestionEight", item: [] },
      data8: { title: "txtOSDIQuestionNine", item: [] },
      //
      data9: {
        tip: "txtOSDIHeadlineThree",
        title: "txtOSDIQuestionTen",
        item: [
          { text: "txtOSDIQuestionOne_itemOneAnother", score: "4" },
          { text: "txtOSDIQuestionOne_itemTwoOther", score: "3" },
          { text: "txtOSDIQuestionOne_itemThreeOther", score: "2" },
          { text: "txtOSDIQuestionOne_itemFourOther", score: "1" },
          { text: "txtOSDIQuestionOne_itemFiveOther", score: "0" },
          { text: "txtOSDIQuestionOne_itemSixOther", score: "-1" }
        ]
      },
      data10: { title: "txtOSDIQuestionEleven", item: [] },
      data11: { title: "txtOSDIQuestionTwelve", item: [] }
    };
  },
  props: {
    history: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  created() {
    this.country = window.settings.language;
  },
  mounted() {
    this.showHistory();
  },
  watch: {
    history(val) {
      this.showHistory();
    }
  },
  methods: {
    compareContry(score) {
      if (this.country === "zh_CN") {
        return true;
      } else if (this.country !== "zh_CN" && score === -1) {
        return false;
      }
    },
    radioClick() {
      let OSDI = [
        this.radiovalue0,
        this.radiovalue1,
        this.radiovalue2,
        this.radiovalue3,
        this.radiovalue4,
        this.radiovalue5,
        this.radiovalue6,
        this.radiovalue7,
        this.radiovalue8,
        this.radiovalue9,
        this.radiovalue10,
        this.radiovalue11
      ];
      this.$emit("emitOSDIFun", OSDI);
    },
    showHistory() {
      this.radiovalue0 = this.history[0];
      this.radiovalue1 = this.history[1];
      this.radiovalue2 = this.history[2];
      this.radiovalue3 = this.history[3];
      this.radiovalue4 = this.history[4];
      this.radiovalue5 = this.history[5];
      this.radiovalue6 = this.history[6];
      this.radiovalue7 = this.history[7];
      this.radiovalue8 = this.history[8];
      this.radiovalue9 = this.history[9];
      this.radiovalue10 = this.history[10];
      this.radiovalue11 = this.history[11];
    }
  }
};
</script>

<style lang="less" scoped>
.OSDI {
  color: #000;
  margin: auto;
  background: #fff;
  // height: 100%;
  overflow: scroll;
  padding-left: 10px;
  margin-right: 4px;
  .OSDICon {
    .title {
      text-align: center;
      line-height: 100px;
      font-weight: normal;
      font-size: 24px;
      letter-spacing: 2px;
      font-size: 26px;
      font-weight: bold;
      span {
        color: #000;
      }
      .firstCopyRight {
        font-size: 18px;
        position: relative;
        bottom: 10px;
        // left: -10px;
      }
      .CopyRightbro {
        position: relative;
        left: -10px;
      }
      .CopyRightson {
        position: relative;
        left: -28px;
      }
    }
    .smtitle {
      display: block;
      margin-bottom: 10px;
      font-size: 26px;
      font-weight: normal;
    }
    .tip {
      color: #000;
      font-size: 26px;
    }
  }
}
/deep/ .el-radio-group {
  display: flex;
}
/deep/ .el-radio {
  position: relative;
  border: 1px solid #ccc;
  background-color: #fff;
  height: 45px;
  /* line-height: 45px; */
  text-align: center;
  flex: 1;
  /* flex-direction: column; */
  justify-content: space-around;
  font-size: 20px;
  margin-bottom: 20px;
  margin-right: 16px;
  cursor: pointer;
  transition: 0.5s;
  height: 65px !important;
  line-height: 43px !important;
}
/deep/ .el-radio__input {
  display: none;
}
/deep/ .el-radio__label {
  color: #000;
  font-size: 26px !important;
}
/deep/ .is-checked {
  background: #409eff33;
}
</style>



// WEBPACK FOOTER //
// src/dryeye/components/questions/CN/OSDI.vue